import React from 'react';
import { getDeviceName, roundTo3Decimal } from "../../../../../../Utils";

const Row = ({ affid, country, device, spends, conversions, eCost }) => {
    return (
        <tr>
            <td>{affid}</td>
            <td>{country}</td>
            <td>{getDeviceName(device)}</td>
            <td>{spends}</td>
            <td>{conversions}</td>
            <td>{roundTo3Decimal(eCost)}</td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/PeriodCountryTable/components/Row/index.js